// Step 2 (Behandlung) rules — what blocks "Weiter". Dates are yyyy-mm-dd strings, so plain string
// comparison orders them correctly.
//
// There's no invoice date to enter: like every invoice in the app, the printed Rechnungsdatum is
// the day it's sent (generateInvoicePDF: sentDate ?? creationDate), and dunning counts from it.
// At least one diagnosis is required (decided 2026-10-21) — the server checks it too (NO_DIAGNOSIS).

import { parseDiagnosis, withDefaultCertainty } from "./diagnosisText";

export type TreatmentIssue ="ownerMissing" | "noTreatmentDay" | "treatmentInFuture" | "noDiagnosis";

export function treatmentIssues(input: { ownerId: string; treatmentDates: string[]; today: string; diagnoses: string[] }): TreatmentIssue[] {
    const issues: TreatmentIssue[] = [];
    if (!input.ownerId) issues.push("ownerMissing");
    if (input.treatmentDates.length === 0) issues.push("noTreatmentDay");
    else if (input.treatmentDates.some((d) => d > input.today)) issues.push("treatmentInFuture");
    if (input.diagnoses.length === 0) issues.push("noDiagnosis");
    return issues;
}

/** Adds a day, keeping the list sorted and unique. */
export const addTreatmentDate = (dates: string[], date: string) =>
    date && !dates.includes(date) ? [...dates, date].sort() : dates;

/** Adds a diagnosis unless it's empty or already there (case-insensitive; a coded one by its ICD code).
 *  A coded diagnosis without a certainty marker gets G. */
export const addDiagnosis = (diagnoses: string[], text: string) => {
    const clean = withDefaultCertainty(text);
    const code = parseDiagnosis(clean).code;
    if (!clean || diagnoses.some((d) => d.toLowerCase() === clean.toLowerCase() || (code && parseDiagnosis(d).code === code))) return diagnoses;
    return [...diagnoses, clean];
};

export const formatDay = (iso: string) => {
    const [y, m, d] = iso.split("-");
    return y && m && d ? `${d}.${m}.${y}` : iso;
};
